module.exports = __webpack_public_path__ + "img/icon1.2e8c1ca9.png";